const isFakeEmail = (email) => {
    const domain = process.env.REACT_APP_FAKE_EMAIL_DOMAIN;
    return email.endsWith(domain);
};
export default isFakeEmail;